module.exports = __webpack_public_path__ + "img/middle-div.5dddf9c5.jpg";